"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomer = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
const saltHashEmail_1 = require("../helper/saltHashEmail");
const getCustomerState_1 = require("../helper/getCustomerState");
function getCustomerSalutation(order) {
    switch (order.billingAddress.formOfAddress) {
        case 'female':
            return 'Frau';
        case 'male':
            return 'Herr';
        case 'other':
            return 'Other';
        default:
            return undefined;
    }
}
function trackCustomer(order) {
    if (Object.keys(order).length > 0) {
        const customerData = {
            ...(0, getCustomerState_1.getCustomerState)(),
            email: order.email.toLowerCase(),
            emailsha256salt: (0, saltHashEmail_1.saltHashEmail)(order.email),
            salutation: getCustomerSalutation(order),
            firstname: order.billingAddress.firstName,
            lastname: order.billingAddress.lastName,
            street: order.billingAddress.streetName,
            housenumber: order.billingAddress.streetNumber,
            zipcode: order.billingAddress.zipCode,
            city: order.billingAddress.city,
            countrycode: order.billingAddress.countryCode,
        };
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
        const dataLayer = window?.dataLayer;
        const customerIndex = window.dataLayer.findIndex(item => item?.Customer);
        if (customerIndex) {
            dataLayer[customerIndex] = { Customer: customerData };
            window.dataLayer = dataLayer;
        }
        else {
            (0, pushToDataLayer_1.pushToDataLayer)({ Customer: customerData });
        }
    }
}
exports.trackCustomer = trackCustomer;
//# sourceMappingURL=trackCustomer.js.map